














import { Component, Mixins, Prop } from "vue-property-decorator";
import UtilMixin from "@/mixins/utilMixin";
import { LlmParameter, DefaultLlmParameter } from "#/model/admin/index";
import RulesMixin from "#/mixins/rulesMixin";
import LLMParameterSetting from "@/components/ai/LLMParameterSetting.vue";

@Component({ components: { LLMParameterSetting } })
/**
 * OpenAI設定
 */
export default class extends Mixins(UtilMixin, RulesMixin) {
  /** Prop */

  /** 入力値 */
  @Prop({ default: () => DefaultLlmParameter() }) value!: LlmParameter;

  /** 詳細パラメータ表示フラグ */
  @Prop({ default: () => false }) showParameterSetting!: boolean;

  /** 変数 */

  /** geminiモデル選択肢 */
  private geminiChoice = [
    { text: "Gemini 3.5 Flash", value: "gemini-3.5-flash" },
    { text: "Gemini 3.1 Flash Lite", value: "gemini-3.1-flash-lite" },
    { text: "Gemini 3.1 Pro Preview", value: "gemini-3.1-pro-preview" },
    { text: "Gemini 2.5 Pro", value: "gemini-2.5-pro" },
    { text: "Gemini 2.5 Flash", value: "gemini-2.5-flash" },
  ];
}
